module.exports = "/_next/static/images/capa-poly-bg-2e253145cb3aa30128c831a1bba44ca7.jpg";